// A mention the RESEED can return: a structured id in `mentions` that names the
// viewer, or one of the three literal group tokens getMentionCounts matches with a
// case-SENSITIVE LIKE (pg-sync.ts). `@all` and a plain-text `@name` are neither.
import { isMe, type ViewerIdentity } from "./session-scope.js";

const SERVER_GROUP_TOKENS = ["@everyone", "@here", "@channel"] as const;

export function serverCountableMention(
  mentions: readonly string[] | null | undefined,
  text: string,
  viewer: ViewerIdentity,
): boolean {
  if (mentions?.some((m) => isMe(m, viewer)) === true) return true;
  return SERVER_GROUP_TOKENS.some((token) => text.includes(token));
}
